import { useLanguage } from "@/contexts/LanguageContext"

const ProjectsSection = () => {
  const { t } = useLanguage()
  
  const projects = [
    {
      title: t('projects.weather.title'),
      category: t('projects.weather.category'),
      problem: t('projects.weather.problem'),
      approach: t('projects.weather.approach'),
      result: t('projects.weather.result'),
      metrics: t('projects.weather.metrics')
    },
    {
      title: t('projects.mvp.title'),
      category: t('projects.mvp.category'), 
      problem: t('projects.mvp.problem'),
      approach: t('projects.mvp.approach'),
      result: t('projects.mvp.result'),
      metrics: t('projects.mvp.metrics')
    },
    {
      title: t('projects.automation.title'),
      category: t('projects.automation.category'),
      problem: t('projects.automation.problem'),
      approach: t('projects.automation.approach'),
      result: t('projects.automation.result'),
      metrics: t('projects.automation.metrics')
    }
  ]

  return (
    <section id="projects" className="py-20 bg-je-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-black text-je-black mb-4">
            {t('projects.title')}
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            {t('projects.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {projects.map((project, index) => (
            <div
              key={index}
              className="bg-gradient-card p-8 rounded-xl shadow-card hover:shadow-hover transition-all duration-300 card-hover scroll-reveal"
              style={{animationDelay: `${index * 120}ms`}}
            >
              <div className="mb-4">
                <span className="inline-block bg-je-red text-je-white text-sm font-semibold px-3 py-1 rounded-full mb-3">
                  {project.category}
                </span>
                <h3 className="text-2xl font-bold text-je-black mb-2">
                  {project.title}
                </h3>
                <p className="text-sm font-medium text-je-red">
                  {project.metrics}
                </p>
              </div>

              <div className="space-y-4">
                <div>
                  <h4 className="font-semibold text-je-black mb-1">{t('projects.problem')}</h4>
                  <p className="text-muted-foreground text-sm leading-relaxed">
                    {project.problem}
                  </p>
                </div>

                <div>
                  <h4 className="font-semibold text-je-black mb-1">{t('projects.approach')}</h4>
                  <p className="text-muted-foreground text-sm leading-relaxed">
                    {project.approach}
                  </p>
                </div>

                <div>
                  <h4 className="font-semibold text-je-black mb-1">{t('projects.result')}</h4>
                  <p className="text-muted-foreground text-sm leading-relaxed">
                    {project.result}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default ProjectsSection